import { createAction, props } from '@ngrx/store';
import { SaveContactData, SelfRegistrationConfig } from '@ui/shared/models';

export const FetchSelfRegistrationConfig = createAction(
  '[Offline Self Registration] Fetch Self Registration Config',
  props<{
    token: string;
  }>()
);

export const FetchSelfRegistrationConfigSuccess = createAction(
  '[Offline Self Registration] Fetch Self Registration Config Success',
  props<{
    selfRegistrationConfig: SelfRegistrationConfig;
  }>()
);

export const FetchSelfRegistrationConfigFail = createAction(
  '[Offline Self Registration] Fetch Self Registration Config Fail',
  props<{
    error: Error;
  }>()
);

export const SelfRegisterOfflineContact = createAction(
  '[Offline Self Registration] Self Register Offline Contact',
  props<{
    payload: SaveContactData;
  }>()
);

export const SelfRegisterOfflineContactSuccess = createAction(
  '[Offline Self Registration] Self Register Offline Contact Success'
);

export const SelfRegisterOfflineContactFail = createAction(
  '[Offline Self Registration] Self Register Offline Contact Fail',
  props<{
    error: Error;
  }>()
);

export const ResetSelfRegistrationActionState = createAction(
  '[Offline Self Registration] Reset Register Self Registration Action State'
);
